export const yellow = "Okb";
export const green = "Pkb";
export const pink = "Qkb";
export const purple = "Rkb";
export const blue = "Skb";
export const gray = "Tkb";
export const charcoal = "Ukb";
export const white = "Vkb";
export default {yellow,green,pink,purple,blue,gray,charcoal,white};